module.exports = __webpack_public_path__ + "img/tooltips_text_only.adb022e0.webp";